import { Edit } from "@mui/icons-material";
import { Box, Button, Modal, Stack, TextField, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import LocalstorageHelper from "../../../../LocalStorageHelper/LocalstorageHelper";
toast.configure();

const DestinationEdit = ({ dest, allDest , allStates}) => {
  const userToken = LocalstorageHelper.GetUserToken();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    "& button": { m: 1 },
  };

  const [destName, setDestName] = useState(dest.destname);
  const [stateid, setStateid] = useState(dest.stateid);
  const [helpText, setHelpText] = useState(""); // change helper text
  const [disabled, setDisabled] = useState(false); //UPDATE BUTTON STATE
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setDestName(dest.destname);
  };

  //Edit Data Function

  const updateDetails = async (e) => {
    e.preventDefault();
    try {
      const body = { destName,stateid };
      const response = await fetch(
        `/ledger/updatedest/${dest.destid}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json", sptoken: userToken },
          body: JSON.stringify(body),
        }
      );
      const parseRes = await response.json();
      toast(parseRes, { autoClose: 1000 });
      setOpen(false);
      setTimeout(() => {
        window.location.reload(false);
      }, 1000);
    } catch (err) {
      console.error(err.message);
    }
  };

  ///CHECK IF THE Sub Group EXISTS ALREADY
  const handleCheck = (e) => {
    let value = e.target.value;
    let newValue = value.toUpperCase();
    setDestName(e.target.value);
    if (allDest.map((a) => a.destname).includes(newValue)) {
      setHelpText("Already Exists!");
      setDisabled(true);
    } else {
      setHelpText("");
      setDisabled(false);
    }
  };

  return (
    <div>
      <Button variant="contained" size="small" onClick={handleOpen}>
        <Edit />
      </Button>
      <Modal
        open={open}
        aria-labelledby="Edit Sub Group"
        aria-describedby="edit Subgroupname and Update"
      >
        <Box sx={style}>
          <Stack
            component="form"
            sx={{
              width: "30ch",
            }}
            spacing={5}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="stateName"
              required
              select
              label="State Name"
              value={stateid}
              onChange={(e) => {
                setStateid(e.target.value);
              }}
              variant="standard"
              sx={{
                width: "100%",
              }}
            >
              {allStates.map((option) => (
                <MenuItem key={option.stateid} value={option.stateid}>
                  {option.statename}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="destinationName"
              label="Destination Name"
              variant="standard"
              helperText={helpText}
              value={destName}
              onChange={handleCheck}
            />
            <Button
              disabled={disabled}
              variant="contained"
              size="medium"
              color="primary"
              onClick={(e) => updateDetails(e)}
            >
              Update
            </Button>
            <Button
              variant="contained"
              size="medium"
              onClick={handleClose}
              color="error"
            >
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default DestinationEdit;
